/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { JobChangeOrderRestService } from '@gh/builder-shared-data';
import { getRouteParam, InitViewService } from '@gh/common-shared';
import { ID } from '@gh/common-shared-data';
import { GridLayoutService } from '@gh/core-ui-grid';
import { map$ } from '@gh/rx/operators';
import { Observable } from 'rxjs';
import { getEmptyJobCo, jobCoFromDto, JobCoList } from './job.model';

@Injectable()
export class JobCoListBusinessService implements InitViewService {
  constructor(private jobChangeOrderRest: JobChangeOrderRestService,
              private gridLayoutService: GridLayoutService) {
  }

  initView(route: ActivatedRouteSnapshot): any {
    const jobId = getRouteParam(route, 'jobId');

    return {
      jobCo: jobId ? this.get(jobId) : getEmptyJobCo(),
      gridLayout: this.gridLayoutService.get('jobCo'),
    };
  }

  get(jobId: ID): Observable<JobCoList> {
    return this.jobChangeOrderRest.findAll(jobId).pipe(map$(jobCoFromDto));
  }
}
